import { useState } from 'react';
import { Alert, AlertDescription, Spinner } from '@klaro7/ui';

import { useLeads } from '@/features/leads/hooks/useLeads';
import { LeadStatsCards } from '@/features/leads/components/LeadStatsCards';
import { LeadFilters } from '@/features/leads/components/LeadFilters';
import { LeadTable } from '@/features/leads/components/LeadTable';

export function AdminWaitlistPage() {
  const [page, setPage] = useState(1);
  const [type, setType] = useState<'USER' | 'PROFESSIONAL' | undefined>(undefined);
  const [search, setSearch] = useState('');

  const { data, isLoading, isError, isFetching, refetch } = useLeads({
    page,
    limit: 10,
    type,
    search: search || undefined,
  });

  const handleTypeChange = (newType: 'USER' | 'PROFESSIONAL' | undefined) => {
    setType(newType);
    setPage(1);
  };

  const handleSearchChange = (newSearch: string) => {
    setSearch(newSearch);
    setPage(1);
  };

  return (
    <div className="space-y-6">
      {/* Page header */}
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-neutral-900">Lista d'Attesa</h1>
          <p className="mt-1 text-sm text-neutral-500">Utenti e professionisti registrati dalla piattaforma</p>
        </div>
        <button
          type="button"
          onClick={() => refetch()}
          disabled={isFetching}
          className="inline-flex shrink-0 items-center gap-2 rounded-lg border border-neutral-200 bg-white px-4 py-2 text-sm font-medium text-neutral-700 transition-colors hover:bg-neutral-50 disabled:opacity-50"
        >
          <svg
            className={`h-4 w-4 ${isFetching ? 'animate-spin' : ''}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          {isFetching ? 'Aggiorno…' : 'Aggiorna'}
        </button>
      </div>

      <LeadStatsCards />

      {isError && (
        <Alert variant="error">
          <AlertDescription>
            Errore nel caricamento dei dati. Riprova più tardi.
          </AlertDescription>
        </Alert>
      )}

      {/* Table container */}
      <div className="overflow-hidden rounded-xl border border-neutral-200 bg-white">
        <div className="border-b border-neutral-100 px-5 py-4">
          <LeadFilters
            activeType={type}
            onTypeChange={handleTypeChange}
            search={search}
            onSearchChange={handleSearchChange}
          />
        </div>

        {isLoading ? (
          <div className="flex justify-center py-12">
            <Spinner size="lg" />
          </div>
        ) : (
          <LeadTable
            leads={data?.data ?? []}
            pagination={data?.pagination}
            page={page}
            onPageChange={setPage}
          />
        )}
      </div>
    </div>
  );
}
